import { Component, Input, OnChanges, Output, EventEmitter, OnInit, OnDestroy, ViewChild, ElementRef, AfterViewInit } from '@angular/core';

import { CustomLandingFactory } from '@shared/factories/custom-landing/custom-landing.factory';

import { FieldTypeListParentService } from './../utils/field-type-list-parent.service';
import { ByWordPipe } from '../../../filters/by-word/by-word.pipe';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { AfOrderByPipe } from '@shared/filters/af-order-by/af-order-by.pipe';
import { TreeListChildrenComponent } from '../tree-list-children/tree-list-children.component';
import { SpanTooltipComponent } from '../../span-tooltip/span-tooltip.component';
import { AfTranslateDirective } from '../../../modules/translate/directive/af-translate.directive';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'primeng/tooltip';
import { TooltipLawComponent } from '../../tooltip-law/tooltip-law.component';
import { TooltipInfoComponent } from '../../tooltip-info/tooltip-info.component';
import { NgClass, NgStyle } from '@angular/common';
import { TreeSelectedMultipleComponent } from '../tree-selected-multiple/tree-selected-multiple.component';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import { TooltipInReportComponent } from "../../tooltip-in-report/tooltip-in-report.component";

@Component({
    selector: 'field-type-list-multiple',
    templateUrl: './field-type-list-multiple.component.html',
    standalone: true,
    imports: [NgClass,
      NgStyle,
      TreeSelectedMultipleComponent,
      TooltipInfoComponent,
      TooltipLawComponent,
      TooltipModule,
      FormsModule,
      AfTranslateDirective,
      SpanTooltipComponent,
      TreeListChildrenComponent,
      AfOrderByPipe,
      AfTranslatePipe,
      ByWordPipe,
      OverlayPanelModule,
      TooltipInReportComponent
    ]
})

export class FieldTypeListMultipleComponent implements OnChanges, OnInit, AfterViewInit, OnDestroy {
  selectionAsArray:boolean = false;
  isLanding = this.customLanding.isLanding();
  fieldTypeList:any = this.fieldTypeListParent.configureFieldTypeList(this);

  constructor(
    private customLanding: CustomLandingFactory,
    private fieldTypeListParent: FieldTypeListParentService) {}

  @Input() field:any = null;
  @Input() preSelectItem:any = '';
  @Input() listValues:any = [];
  @Input() listAll:any = [];
  @Input() public: boolean = false;
  @Input() type:any = '';
  @Input() orderBy:any;
  @Input() fieldToFind: string = 'text';
  @Output() itemSelected = new EventEmitter();
  @Output() openRelatedInfo = new EventEmitter();
  @ViewChild('containerFieldList') containerFieldListElement: ElementRef;
  @ViewChild('fieldTypeListMultipleOverlay') fieldTypeListMultipleOverlay: OverlayPanel;

  ngAfterViewInit(): void {
    this.fieldTypeListParent.configureAfterViewInit(this.fieldTypeListMultipleOverlay);
  }

  ngOnInit(): void {
    this.fieldTypeListParent.openWatchers(this);
  }

  ngOnChanges(): void {
    this.fieldTypeListParent.configureChanges(this);
    let allDisabled:number = 0
    for(let i = 0; i < this.listValues?.length; i++){
       allDisabled += this.listValues[i].disabled? 1 : 0;
    }
    this.fieldTypeList.allDisabled = allDisabled === this.listValues?.length;
  }

  toggleAll(){
    this.fieldTypeListParent.toggleAll(this);
  }

  createNewValue(){
    this.fieldTypeListParent.createNewValue(this)
  }

  insertNewValue(){
    this.fieldTypeListParent.insertNewValue(this);
  }

  editListValueElement(listValue:any){
    this.fieldTypeListParent.editListValueElement(listValue, this);
  }

  deleteListValue(listValue:any){
   this.fieldTypeListParent.deleteListValue(listValue, this)
  }

  aceptNotDelete(){
    this.fieldTypeList.deleteError = false;
  }

  resetField(){
    this.fieldTypeListParent.resetField(this);
  }

  resetAllValues(){
    this.fieldTypeListParent.resetAllValues(this, this.listValues);
  }

  resetListValue(){
    this.fieldTypeListParent.resetListValue(this);
  }

  addOrDeleteSelectedValue(listValue:any){
    if(this.field.uniqueLastSelect && listValue.children?.length){
      this.showChildren(listValue);
    }else if(!listValue.disabled){
      this.fieldTypeList.markAll = false;
      this.fieldTypeListParent.addOrDeleteSelectedValue(listValue, this);
    }
  }

  closeList(){
    this.fieldTypeListParent.closeList(this);
  }

  showChildren(listValue:any){
    listValue.show = !listValue.show;
  }

  changeList(){
    this.fieldTypeListParent.changeList(this);
  }

  resetSearch(){
    this.fieldTypeListParent.resetSearch(this);
  }

  openModalRelatedInfo(fieldRelatedInfo:any){
    this.fieldTypeListParent.openModalRelatedInfo(fieldRelatedInfo, this);
  }

  treeMultipleOn(event: any){
    this.addOrDeleteSelectedValue(event.listValue);
  }

  checkListValue(listValue:any){
    return !(listValue?.type?.toLowerCase()==='back' && !listValue.show);
  }

  toggleFilter(e: any){
    this.fieldTypeListParent.toggleFilter(e, this.fieldTypeListMultipleOverlay, this);
  }

  ngOnDestroy(){
      this.fieldTypeListParent.ngOnDestroy();
  }
}
